<template>
  <!--
      作者：wangxw
      时间：2020-06-10
      描述：页面-首页
  -->
  <div v-loading="loading" class="diy-container clearfix">

    <!--类别选择-->
    <div class="diy-menu"><Type v-if="!loading" :defaultData="defaultData"></Type></div>

    <!--手机diy容器-->
    <div class="diy-phone"><Model v-if="!loading" ref="model" :form="form" :defaultData="defaultData" :diyData="diyData"></Model></div>

    <!--参数设置-->
    <div class="diy-info"><Params v-if="!loading" :form="form" :defaultData="defaultData" :diyData="diyData"></Params></div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="Submit()" :loading="loading">保存</el-button>
    </div>
  </div>
</template>

<script>
import {deepClone} from '@/utils/base.js'
import PageApi from '@/api/page.js';
import Type from './diy/Type.vue';
import Model from './diy/Model.vue';
import Params from './diy/Params.vue';
export default {
  components: {
    /*组件类别*/
    Type,
    /*组件信息*/
    Model,
    /*参数信息*/
    Params
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*默认数据*/
      defaultData: {},
      /*组件数据列表*/
      diyData: {
        items: []
      },
      opts: {},
      /*表单对象*/
      form: {
        umeditor: {},
        /*当前选中*/
        curItem: {},
        /*当前选中的元素（下标）*/
        selectedIndex: -1
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取列表*/
    // getData() {
    //   let self = this;
    //   let res = {
    //     "code": 1,
    //     "msg": "",
    //     "data": {
    //       "defaultData": {
    //         "banner": {
    //           "name": "图片轮播",
    //           "type": "banner",
    //           "group": "media",
    //           "style": {
    //             "btnColor": "#ffffff",
    //             "btnShape": "round"
    //           },
    //           "params": {
    //             "interval": "2800",
    //             "nav": [
    //               {
    //                 "navimgUrl": "http://47.99.110.39/image/diy/navbar/02.png",
    //                 "navlinkUrl": "",
    //                 "title": "按钮标题1",
    //                 "text": "按钮文字2"
    //               },
    //               {
    //                 "navimgUrl": "http://47.99.110.39/image/diy/navbar/02.png",
    //                 "navlinkUrl": "",
    //                 "title": "按钮标题2",
    //                 "text": "按钮文字2"
    //               },
    //               {
    //                 "navimgUrl": "http://47.99.110.39/image/diy/navbar/02.png",
    //                 "navlinkUrl": "",
    //                 "title": "按钮标题3",
    //                 "text": "按钮文字3"
    //               }
    //             ]
    //           },
    //           "data": [
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/banner/01.png",
    //               "linkUrl": ""
    //             },
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/banner/01.png",
    //               "linkUrl": ""
    //             },
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/banner/01.png",
    //               "linkUrl": ""
    //             }
    //           ]
    //         },
    //         "navBar": {
    //           "name": "导航组",
    //           "type": "navBar",
    //           "group": "media",
    //           "style": {
    //             "background": "#ffffff",
    //             "rowsNum": "1"
    //           },
    //           "data": [
    //             {
    //               "linkUrl": "",
    //               "imageUrl": "",
    //               "title": "按钮标题",
    //               "text": "按钮文字1",
    //               "color": "#666666"
    //             }
    //           ]
    //         },
    //         "blank": {
    //           "name": "辅助空白",
    //           "type": "blank",
    //           "group": "tools",
    //           "style": {
    //             "height": 20,
    //             "background": "#ffffff"
    //           }
    //         },
    //         "guide": {
    //           "name": "辅助线",
    //           "type": "guide",
    //           "group": "tools",
    //           "style": {
    //             "background": "#ffffff",
    //             "lineStyle": "solid",
    //             "lineHeight": "1",
    //             "lineColor": "#000000",
    //             "paddingTop": 10
    //           }
    //         },
    //         "window": {
    //           "name": "图片橱窗",
    //           "type": "window",
    //           "group": "media",
    //           "style": {
    //             "paddingTop": 0,
    //             "paddingLeft": 0,
    //             "background": "#ffffff",
    //             "layout": "2"
    //           },
    //           "title":"标题文本",
    //           "data": [
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/window/01.jpg",
    //               "linkUrl": ""
    //             },
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/window/02.jpg",
    //               "linkUrl": ""
    //             },
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/window/03.jpg",
    //               "linkUrl": ""
    //             },
    //             {
    //               "imgUrl": "http://47.99.110.39/image/diy/window/04.jpg",
    //               "linkUrl": ""
    //             }
    //           ],
    //           "dataNum": 4
    //         },
    //         "article": {
    //           "name": "通告组",
    //           "type": "article",
    //           "group": "media",
    //           "params": {
    //             "source": "auto",
    //             "auto": {
    //               "category": 0,
    //               "showNum": 6
    //             }
    //           },
    //           "style": {
    //             "display": "10"
    //           },
    //           "defaultData": [
    //             {
    //               "article_title": "此处显示通告标题",
    //               "show_type": 10,
    //               "image": "http://47.99.110.39/image/diy/article/01.png",
    //               "views_num": 309
    //             },
    //             {
    //               "article_title": "此处显示通告标题",
    //               "show_type": 10,
    //               "image": "http://47.99.110.39/image/diy/article/01.png",
    //               "views_num": 309
    //             }
    //           ],
    //           "data": []
    //         },
    //         "wxlive": {
    //           "name": "微信直播",
    //           "type": "wxlive",
    //           "group": "shop",
    //           "params": {
    //             "source": "auto",
    //             "showNum": 1
    //           },
    //           "style": {
    //             "background": "#FFFFFF",
    //             "color": "#333333"
    //           },
    //           "defaultData": [
    //             {
    //               "shop_name": "直播间名称",
    //               "logo_image": "http://47.99.110.39/image/diy/circular.png",
    //               "name": "主播昵称"
    //             },
    //             {
    //               "shop_name": "直播间名称",
    //               "logo_image": "http://47.99.110.39/image/diy/circular.png",
    //               "name": "主播昵称"
    //             }
    //           ],
    //           "data": [
    //             {
    //               "name": "直播间名称",
    //               "logo_image": "http://47.99.110.39/image/diy/circular.png",
    //               "anchor_name": "主播昵称"
    //             },
    //             {
    //               "name": "直播间名称",
    //               "logo_image": "http://47.99.110.39/image/diy/circular.png",
    //               "anchor_name": "主播昵称"
    //             }
    //           ]
    //         },
    //         "group": {
    //           "name": "团购组",
    //           "type": "group",
    //           "group": "media",
    //           "params": {
    //             "source": "auto",
    //             "showNum": 2
    //           },
    //           "defaultData": [
    //             {
    //               "group_name": "此处显示团购标题",
    //               "describe": "描述",
    //               "group_price": "280",
    //               "discount": "5.0折",
    //               "line_price": "560",
    //               "image": "http://47.99.110.39/image/diy/group/01.png",
    //               "group_sales": 400
    //             },
    //             {
    //               "group_name": "此处显示团购标题",
    //               "describe": "描述",
    //               "group_price": "280",
    //               "discount": "5.0折",
    //               "line_price": "560",
    //               "image": "http://47.99.110.39/image/diy/group/01.png",
    //               "group_sales": 400
    //             }
    //           ],
    //           "data": []
    //         },
    //         "login": {
    //           "name": "登录",
    //           "type": "login",
    //           "group": "login",
    //           "style": {
    //             "background": "#ffffff"
    //           },
    //           "data": [
    //             {
    //               "linkUrl": "",
    //               "imageUrl": "http://47.99.110.39/image/diy/login/login.png",
    //               "title": "登录标题",
    //               "text": "文字描述"
    //             }
    //           ]
    //         }
    //       },
    //       "jsonData": {
    //         "page": {
    //           "type": "page",
    //           "name": "页面设置",
    //           "params": {
    //             "name": "页面标题",
    //             "title": "页面标题",
    //             "share_title": "分享标题"
    //           },
    //           "style": {
    //             "titleTextColor": "black",
    //             "titleBackgroundColor": "#ffffff"
    //           }
    //         },
    //         "items": [
    //           {
    //             "name": "图片轮播",
    //             "type": "banner",
    //             "group": "media",
    //             "style": {
    //               "btnColor": "#FFFFFF",
    //               "btnShape": "round"
    //             },
    //             "params": {
    //               "interval": "2800",
    //               "nav": [
    //                 {
    //                   "navimgUrl": "http://47.99.110.39/uploads/20230906/09f6bcd036b9cd724c8243f977cc5bd6.png",
    //                   "navlinkUrl": "pages/product/list/store",
    //                   "title": "店内",
    //                   "text": "下单免排队"
    //                 },
    //                 {
    //                   "navimgUrl": "http://47.99.110.39/uploads/20230908/7aa15b3b8d148fb03d45391b78bda50b.png",
    //                   "navlinkUrl": "pages/product/list/takeaway?orderType=takein",
    //                   "title": "自提",
    //                   "text": "无接触配送"
    //                 },
    //                 {
    //                   "navimgUrl": "http://47.99.110.39/uploads/20230908/025f56f57db1c7739d89da7b84dd0e02.png",
    //                   "navlinkUrl": "pages/product/list/takeaway?orderType=takeout",
    //                   "title": "配送",
    //                   "text": "无接触配送"
    //                 }
    //               ]
    //             },
    //             "data": [
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230906/163d5f7185098dd12b8c45ac6b83bbe3.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230906/98722504106854376fad7129a69eb512.jpg",
    //                 "linkUrl": ""
    //               }
    //             ]
    //           },
    //           {
    //             "name": "登录",
    //             "type": "login",
    //             "group": "login",
    //             "style": {
    //               "background": "#ffffff"
    //             },
    //             "data": [
    //               {
    //                 "linkUrl": "pages/user/index/index",
    //                 "imageUrl": "http://47.99.110.39/image/diy/login/login.png",
    //                 "title": "去登录",
    //                 "text": "成为会员可累计积分",
    //                 "name": "链接到 页面 我的"
    //               }
    //             ]
    //           },
    //           {
    //             "name": "导航组",
    //             "type": "navBar",
    //             "group": "media",
    //             "style": {
    //               "background": "#ffffff",
    //               "rowsNum": "1"
    //             },
    //             "data": [
    //               {
    //                 "linkUrl": "pages/article/detail/detail?article_id=3",
    //                 "imageUrl": "http://47.99.110.39/uploads/20230830/5b1d108f26fcc2369a49c4ecb0ffbac6.png",
    //                 "title": "预定",
    //                 "text": "",
    //                 "color": "#666666",
    //                 "name": "链接到 页面 商家简介"
    //               }
    //             ]
    //           },
    //           {
    //             "name": "导航组",
    //             "type": "navBar",
    //             "group": "media",
    //             "style": {
    //               "background": "#ffffff",
    //               "rowsNum": "1"
    //             },
    //             "data": [
    //               {
    //                 "linkUrl": "pages/product/list/ipadStore",
    //                 "imageUrl": "http://47.99.110.39/uploads/20230830/5b1d108f26fcc2369a49c4ecb0ffbac6.png",
    //                 "title": "餐厅介绍",
    //                 "text": "联系方式和营业时间",
    //                 "color": "#666666",
    //                 "name": "链接到 页面 ipad商店"
    //               }
    //             ]
    //           },
    //           {
    //             "name": "图片橱窗",
    //             "type": "window",
    //             "group": "media",
    //             "style": {
    //               "paddingTop": 0,
    //               "paddingLeft": 0,
    //               "background": "#ffffff",
    //               "layout": "3"
    //             },
    //             "data": [
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/e8f508931aea759a7ac269b735250145.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/62d1fffa96ed3d2fe1df3de2699367ee.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/e478a77e1be7f9552b757c71519d4982.jpg",
    //                 "linkUrl": ""
    //               }
    //             ],
    //             "dataNum": 4
    //           },
    //           {
    //             "name": "图片橱窗",
    //             "type": "window",
    //             "group": "media",
    //             "style": {
    //               "paddingTop": 0,
    //               "paddingLeft": 0,
    //               "background": "#ffffff",
    //               "layout": "2"
    //             },
    //             "data": [
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/62e8806221c31ab134d3cd076448210a.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/d3d1fe24e633ef768d30266c23057240.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/6b6ff06c7a8e1a4cdcd7e4494ae106a7.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/15f317f8359c9f3591d88a4171aad47f.jpg",
    //                 "linkUrl": ""
    //               }
    //             ],
    //             "dataNum": 4
    //           },
    //           {
    //             "name": "图片橱窗",
    //             "type": "window",
    //             "group": "media",
    //             "style": {
    //               "paddingTop": 0,
    //               "paddingLeft": 0,
    //               "background": "#ffffff",
    //               "layout": "-1"
    //             },
    //             "data": [
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/ad2f1b793a4a77c956ed92cfca500a9d.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/2948b48bb1a7404a9525062fbd33d317.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/9447f58f446c3b362b6c86aa8c260c4f.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/4027502a0ae2b7c415caa0747bbbc3db.jpg",
    //                 "linkUrl": ""
    //               }
    //             ],
    //             "dataNum": 4
    //           },
    //           {
    //             "name": "图片橱窗",
    //             "type": "window",
    //             "group": "media",
    //             "style": {
    //               "paddingTop": 0,
    //               "paddingLeft": 0,
    //               "background": "#ffffff",
    //               "layout": "4"
    //             },
    //             "data": [
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/9574c5f4bc29cdb35d4b3d0bf8cc0594.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/27b3312a4a6ef41360a0a838364879b1.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/a1fc18ea46d4a8da261e1da66281e87c.jpg",
    //                 "linkUrl": ""
    //               },
    //               {
    //                 "imgUrl": "http://47.99.110.39/uploads/20230904/9b2475f334f70b7b8b2106c1b34c0672.jpg",
    //                 "linkUrl": ""
    //               }
    //             ],
    //             "dataNum": 4
    //           },
    //           {
    //             "type": "search",
    //             "name": "搜索框",
    //             "params": {
    //               "placeholder": "搜索菜品"
    //             },
    //             "style": {
    //               "textAlign": "center",
    //               "searchStyle": "radius"
    //             }
    //           }
    //         ]
    //       },
    //       "opts": {
    //         "catgory": []
    //       }
    //     },
    //   }
    //   self.defaultData = res.data.defaultData;
    //   self.diyData = res.data.jsonData;
    //   self.form.curItem=self.diyData.page;
    //   self.opts = res.data.opts;
    //   self.loading = false;
    // },

    getData() {
      let self = this;
      PageApi.editHome({}, true)
        .then(res => {
          self.defaultData = res.data.defaultData;
          self.diyData = res.data.jsonData;
          self.form.curItem=self.diyData.page;
          self.opts = res.data.opts;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

   /*新增Diy组件*/
   onAddItem: function(key) {
     // 复制默认diy组件数据
     let item = deepClone(this.defaultData[key]),cur_index=0;
     if(this.form.selectedIndex<0){
       cur_index=0;
       this.diyData.items.unshift(item);
     }else{
       cur_index=this.form.selectedIndex + 1;
        this.diyData.items.splice(cur_index,0,item);
     }
     // 编辑当前选中的元素
     this.$refs.model.onEditer(cur_index);
   },

    /*上架*/
    Submit() {
      let self = this;
      self.loading = true;
      let params = self.diyData;
      let page_id = self.page_id;
      PageApi.SavePage(
        {
          params: JSON.stringify(params),
          page_id: page_id
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: self.$t('恭喜你，修改成功'),
            type: 'success'
          });
          self.getData();
          self.form.selectedIndex= -1;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/page/diy.scss';
</style>



// WEBPACK FOOTER //
// src/views/page/page/home.vue